import { Injectable } from '@angular/core';
import { InsuranceCoverageModel } from '../../../../models/insurance-coverage.model';
import {ApplicationStateStorageService} from '../../../../../shared/services/application-state-storage.service';
import {ApplicationStateService} from '../../../../../shared/services/application-state.service';
import {SalesChannel} from '../../../../consts/sales-channel.enum';
import {OfferPrimaryCoverageCode} from '../../../../consts/offer-primary-coverage-code.enum';

@Injectable({
  providedIn: 'root'
})
export class InsuranceCoverageService {

  constructor(private stateService: ApplicationStateService,
              private storage: ApplicationStateStorageService) {
  }

  get insuranceCoveragesSelectionEnabled(): boolean {
    return this.stateService.salesChannel !== SalesChannel.YANOSIK;
  }

  get insuranceCoverage(): InsuranceCoverageModel {
    return this.stateService.state.insuranceCoverages;
  }

  get selectedInsuranceCoverages(): string[] {
    return Object.keys(OfferPrimaryCoverageCode).filter(coverage => this.insuranceCoverage[coverage]);
  }

  changeInsuranceCoverage(coverage: OfferPrimaryCoverageCode, value: boolean): void {
    this.insuranceCoverage[coverage] = value;
    this.storage.updateApplicationState();
  }
}
